import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const InfoRowWrapper = styled.div`
  margin-bottom: 0.75rem;

  ${mediaQuery('md')} {
    width: 49rem;
  }
`;
